import type { OrganizationFeatureDefinition } from "../constants/organizationsAdmin.constants";
import type { AdminOrganization, GlobalFeatures } from "../types/organizationsAdmin.types";

/**
 * `global`: on for all, so the organization has it whatever its own switch says. `blocked`: off for all, so
 * it does not, whatever its own switch says (which is kept).
 */
export type OrganizationFeatureState = "on" | "off" | "global" | "blocked";

export function organizationFeatureState(
  organization: AdminOrganization,
  definition: OrganizationFeatureDefinition,
  globalFeatures: GlobalFeatures | null,
): OrganizationFeatureState {
  const mode = definition.global ? globalFeatures?.[definition.global] : undefined;
  if (mode === "on_for_all") return "global";
  if (mode === "off_for_all") return "blocked";
  return organization[definition.feature] ? "on" : "off";
}
